import React from 'react'
import './styles.scss'

const Header1 = () => {
	return (
		<div className="upsell-header1">
			<div className="upsell-header1__title">
				Add into your order 100+ new presets{' '}
				<span>used by influencers in Tik-Tok and Instagram</span>
			</div>
			<ul className="upsell-header1__list">
				<li className="upsell-header1__list-item">
					<img src="images/upsell/pick.png" alt={'>'} />
					Explore super features to improve post quality
				</li>
				<li className="upsell-header1__list-item">
					<img src="images/upsell/pick.png" alt={'>'} />
					Play with colors in automated modes and save time on edits
				</li>
			</ul>
		</div>
	)
}

export { Header1 }
